import { useEffect } from 'react';

const HIDE_DELAY = 2000; // 2 seconds
const PROXIMITY_THRESHOLD = 20; // pixels from right edge

export function useScrollbarVisibility() {
  useEffect(() => {
    let scrollTimeout: NodeJS.Timeout;

    const handleScroll = () => {
      document.body.classList.add('scrolling');
      
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        document.body.classList.remove('scrolling');
      }, HIDE_DELAY);
    };

    const handleMouseMove = (e: MouseEvent) => {
      const distanceFromRight = window.innerWidth - e.clientX;
      
      if (distanceFromRight <= PROXIMITY_THRESHOLD) {
        document.body.classList.add('near-scrollbar');
      } else {
        document.body.classList.remove('near-scrollbar');
      }
    };

    // Add event listeners
    window.addEventListener('scroll', handleScroll, true);
    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('scroll', handleScroll, true);
      window.removeEventListener('mousemove', handleMouseMove);
      clearTimeout(scrollTimeout);
      document.body.classList.remove('scrolling', 'near-scrollbar');
    };
  }, []);
}
